export class UsuariosModel {
  id_usuario: number;
  id_status: number;
  id_cargo: number = 0;
  id_cargo_nome: number = 0;
  id_pais: number = 1;
  master: boolean;
  email: string;
  senha: string;
  senha_conf: string;
  nome: string;
  telefone: string;
  celular: string;
  avatar: string = '/assets/assets/images/faces/face4.png';
  cidade: string;
  estado: string;
  tema: string;
  date_format: string = 'DD/MM/YYYY';
  time_format: string = 'HH:mm';
  timezone: string = 'America/Sao_Paulo';
  idioma: string = 'pt';
  created_at: string;
  updated_at: string;
  deleted_at: string;
  last_login: string;
  id_unidade: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios.model.ts